module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0094.jpg?v=72595875";